import { setBalance } from 'core/store/reducers/appReducer/AppSlice';
import {
	musicVideoScenesDataSelector,
	musicVideoScenesListSelector,
	setMusicVideoScenesData,
	setMusicVideoScenesList,
} from 'core/store/reducers/intermediateMediaReducer/IntermediateMediaSlice';
import { addCharacterNameToText } from 'core/utils/utils';

export const loadMusicVideoScenesMediaFromSocket = (generationDetails) => (dispatch, getState) => {
	const musicVideoScenesData = musicVideoScenesDataSelector(getState());
	const musicVideoScenesList = musicVideoScenesListSelector(getState());

	const { media_id: mediaId, sub_generations: generatedMedia, credits } = generationDetails;

	if (musicVideoScenesList[mediaId]) {
		const currentMediaData = { ...musicVideoScenesData };
		const currentMediaList = [...(musicVideoScenesList[mediaId] || [])];

		Object.keys(generatedMedia).forEach((sceneId) => {
			const sceneData = generatedMedia[sceneId];
			currentMediaData[sceneId] = {
				...currentMediaData[sceneId],
				url: sceneData?.url || '',
				status: sceneData?.status || 'pending',
				character: sceneData?.character?.id || null,
				prompt: addCharacterNameToText(sceneData?.prompt, sceneData?.character?.name),
			};

			if (!currentMediaList.includes(sceneId)) {
				currentMediaList.push(sceneId);
			}
		});

		dispatch(setMusicVideoScenesData(currentMediaData));
		dispatch(setMusicVideoScenesList({ ...musicVideoScenesList, [mediaId]: currentMediaList }));

		if (credits != null) {
			dispatch(setBalance(credits));
		}
	}
};
